import React from 'react';
import {ThemedImage} from '../ui/ThemedImage';

import LogoLight from '../../assets/images/oskalogo.png';
import LogoDark from '../../assets/images/oskalogo-dark.png';

type BrandProps = {
    className?: string;
};

const Brand: React.FC<BrandProps> = ({className = ""}) => {
    return (
        <ThemedImage
            lightSrc={LogoLight}
            darkSrc={LogoDark}
            alt="Oska Yazılım"
            className={className}
        />
    );
};

export default Brand;